import { Table } from '@/components/document/table'

export const Index = () => {
  return (
    <>
      <div className="flex flex-col gap-12">
        <Table pageSize={20} onIndex />
      </div>
    </>
  )
}
